import { Button } from '@mui/material';
import { GridColumnConfig } from '../../models/gridCoumnConfig';
import { FormattedValue } from '../formatted-text';

export const ViewCell = (column: GridColumnConfig, onView: (data: any) => void) => {
  return (dataItem: any) => (
    <td>
      <Button onClick={() => onView?.(dataItem.dataItem)}>
        <FormattedValue value={dataItem.dataItem[column.field]} format={column.formatPattern} />
      </Button>
    </td>
  );
};
